import { standardNumberFormat } from "../../../../objects/CommonUse/double_functions";

export const checkCDListForChanges = (CDList, gameDate, transferAmt) => {
    let CDListHasBeenChanged= false;
    let currentCD = false;
    let chgAutoRollover = true;
    let currentCDAmt = 0;
    let CDInstructions = "Enter a one-time amount and select an Auto Rollover " +
        "option to buy a new CD."
    for (let i=0; i<CDList.length; i++){
        CDList[i].updtStatus = "";
        if (CDList[i].autoRollover !== CDList[i].newAutoRollover){
            CDListHasBeenChanged= true;
            CDList[i].updtStatus = "Auto Rollover will be changed.";
        }else{
            CDList[i].updtStatus = "";
        }
        //  ability to change autoRollover turned off when CD is maturing in current month
        //  when entering one-time amount because can change in the list
        if (CDList[i].startDate === gameDate){
            chgAutoRollover = false;
        }

        if (CDList[i].highlightRow === true){
            currentCDAmt = CDList[i].amount;
            if (CDList[i].newAutoRollover === true){
                currentCD = true;
                if (CDList[i].startDate !== gameDate){
                    CDList[i].updtStatus = "CD matures this month, OK to Transfer up to $" +
                    standardNumberFormat(CDList[i].amount) + " to cash." ;
                }
                chgAutoRollover = false;
                CDInstructions = "Enter a one-time amount to add to the CD that is highlighted above."
            }else{
                CDInstructions = "CD will Expire this month. Enter a one-time amount and " +
                    "select Auto Rollover option to create a new CD."
                CDList[i].updtStatus = "CD will mature, $" +
                    standardNumberFormat(CDList[i].amount) + " moved to Cash at the end of the next turn.";
            }
        }
        if (+transferAmt > 0){
            if (CDList[i].newAutoRollover === false && CDList[i].highlightRow === true){
                // skip this CD as it will auto close at end of month
            }else{
                if (+transferAmt >= +CDList[i].amount){
                    CDList[i].updtStatus = "This CD will be closed out."
                }else{
                    CDList[i].updtStatus = "CD Amount will be reduced."
                }
                transferAmt -= +CDList[i].amount;
            }           
        }
      
    }
   
    const returnObj = {CDListHasBeenChanged: CDListHasBeenChanged, currentCD: currentCD, 
        currentCDAmt: currentCDAmt, chgAutoRollover: chgAutoRollover, CDInstructions: CDInstructions
    };
    return returnObj;
}
export default checkCDListForChanges;